export const BRAND = { green: "#00604A", orange: "#F45118", muted: "#667085", line: "#E4E7E5" };

export const BED_STATUS = {
  vacant: { label: "Available", color: "#FF8C1A", blink: true },
  reserved: { label: "Reserved", color: "#2563EB", blink: false },
  occupied: { label: "Occupied", color: "#DC2626", blink: false },
  checkout_due: { label: "Checkout due", color: "#EAB308", blink: true },
  maintenance: { label: "Maintenance", color: "#9CA3AF", blink: false },
  blocked: { label: "Blocked", color: "#475569", blink: false },
};

export const BED_TYPE = { single: "Single", lower_bunk: "Lower bunk", upper_bunk: "Upper bunk" };
export const ROOM_TYPE = { dormitory: "Dormitory", private: "Private", semi_private: "Semi-private" };

export const inr = (n) => `₹${Number(n || 0).toLocaleString("en-IN")}`;

export const today = () => new Date().toISOString().slice(0, 10);

export const errMsg = (e, fb = "Something went wrong") => {
  const d = e?.response?.data?.detail;
  return typeof d === "string" ? d : fb;
};
